// import { store } from '../store';

// const globParams = {
//   REDIRECIONA_PARA_CARRINHO: 1,
//   ENVIA_EMAIL_SERVIDOR: 2,
//   PERMITE_EMPRESA_CONVERSAO: 3,
//   PERMITE_MENU_PERSONALIZADO: 4,
//   PERMITE_GERACAO_TOKEN: 5,
//   ROTULO_INTEGRACAO_EXT_EXTRA_01: 6,
//   ROTULO_INTEGRACAO_EXT_EXTRA_02: 7,
//   ROTULO_INTEGRACAO_EXT_EXTRA_03: 8,
//   ROTULO_INTEGRACAO_EXT_EXTRA_04: 9,
//   PERMITE_EMAIL_USUARIO_RESPONSAVEL: 10,
//   PERMITE_SERIE_LOTE_CATALOGO: 11,
//   ENVIA_WHATSAPP_SERVIDOR: 12,
//   ENVIA_EMAIL_SOLICITAR: 13,
//   ITEM_OS_SISMA: 14,
//   USA_FILTRO_ANOFAB_NSERIE: 15,
//   USA_MICROFONE: 16,
//   NECESSITA_14_USA_MOTIVO_FALHA: 17,
//   NECESSITA_14_USA_AGENTE_CAUSA: 18,
//   NECESSITA_14_USA_SECAO_TRABALHO: 19,
//   LIMITA_QTD_MAX: 20,
//   LIMITA_QTD_MIN: 21,
//   LIMITE_ITEM_QTD_ZERO: 22,
//   QTD_ITEM_INIC_0: 23,
//   TEMP_DISP_WHATSAPP: 24,
//   VINCULA_CATALOGO_USUARIO: 25,
//   UTILIZA_SOLICITAR_PECAS: 26,
//   UTILIZA_CONJUNTO: 27,
//   UTILIZA_VISUALIZACAO_FACES_SISTEMA: 28,
//   SOLICITA_ATUALIZACAO_PARTNUMBER: 29,
//   PERMITE_PARTNUMBER_ANTERIORES: 30,
//   APROVACAO_AUTOMATICA_ATUALIZACAO_PARTNUMBER: 31,
//   USA_IDIOMA_CATALOGO: 32,
//   USA_PDF_CATALOGO_CDI: 33,
// };

// function getGlobParam(globParam) {
//   /** verifica estado de autenticação */
//   const { param } = store.getState();
//   const { globParams: params = [] } = param || {};

//   const chave = params.find((p) => p.chave === globParam);

//   const { valor = 0 } = chave || {};

//   return valor;
// }

// export function allowEmpCatalogConversor() {
//   return getGlobParam(globParams.PERMITE_EMPRESA_CONVERSAO) === '1';
// }

// export function allowEmpCustomMenu() {
//   return getGlobParam(globParams.PERMITE_MENU_PERSONALIZADO) === '1';
// }

// export function allowEmpTokenGenerate() {
//   return getGlobParam(globParams.PERMITE_GERACAO_TOKEN) === '1';
// }

// export function redirectToCart() {
//   return getGlobParam(globParams.REDIRECIONA_PARA_CARRINHO) === '1';
// }

// export function sendServerEmail() {
//   return getGlobParam(globParams.ENVIA_EMAIL_SERVIDOR) === '1';
// }

// export function sendServerWhatsApp() {
//   return getGlobParam(globParams.ENVIA_WHATSAPP_SERVIDOR) === '1';
// }

// export function labelExtExtra01() {
//   return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_01);
// }

// export function labelExtExtra02() {
//   return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_02);
// }

// export function labelExtExtra03() {
//   return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_03);
// }

// export function labelExtExtra04() {
//   return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_04);
// }

// export function permiteEmpEmailUsuarioReponsavel() {
//   return getGlobParam(globParams.PERMITE_EMAIL_USUARIO_RESPONSAVEL) === '1';
// }

// export function permiteEmpSerieLoteCatalogo() {
//   return getGlobParam(globParams.PERMITE_SERIE_LOTE_CATALOGO) === '1';
// }

// export function criaItemOSSisma() {
//   return getGlobParam(globParams.ITEM_OS_SISMA) === '1';
// }

// export function usaMotivoFalha() {
//   return getGlobParam(globParams.NECESSITA_14_USA_MOTIVO_FALHA) === '1';
// }

// export function usaAgenteCausa() {
//   return getGlobParam(globParams.NECESSITA_14_USA_AGENTE_CAUSA) === '1';
// }

// export function usaSecaoTrab() {
//   return getGlobParam(globParams.NECESSITA_14_USA_SECAO_TRABALHO) === '1';
// }

// export function enviaEmailSolicitacao() {
//   return getGlobParam(globParams.ENVIA_EMAIL_SOLICITAR) === '1';
// }

// export function useDictaphone() {
//   return getGlobParam(globParams.USA_MICROFONE) === '1';
// }

// export function limitaQtdMax() {
//   return {
//     active:
//       String(getGlobParam(globParams.LIMITA_QTD_MAX)) === '1' ||
//       String(getGlobParam(globParams.LIMITA_QTD_MAX)) === '2',
//     value: Number(getGlobParam(globParams.LIMITA_QTD_MAX)),
//   };
// }

// export function limitaQtdMin() {
//   return {
//     active:
//       String(getGlobParam(globParams.LIMITA_QTD_MIN)) === '1' ||
//       String(getGlobParam(globParams.LIMITA_QTD_MIN)) === '2',
//     value: Number(getGlobParam(globParams.LIMITA_QTD_MIN)),
//   };
// }

// export function limiteItemQtdZero() {
//   return {
//     active: Number(getGlobParam(globParams.LIMITE_ITEM_QTD_ZERO)) > 0,
//     value: Number(getGlobParam(globParams.LIMITE_ITEM_QTD_ZERO)),
//   };
// }

// export function qtdItemInic0() {
//   return getGlobParam(globParams.QTD_ITEM_INIC_0) === '1';
// }

// export function tempDispWhatsapp() {
//   return Number(getGlobParam(globParams.QTD_ITEM_INIC_0)) > 0;
// }

// export function vinculaCatalogoUsuario() {
//   return String(getGlobParam(globParams.VINCULA_CATALOGO_USUARIO)) === '1';
// }

// export function utilizaSolicitarPecas() {
//   return String(getGlobParam(globParams.UTILIZA_SOLICITAR_PECAS)) === '1';
// }

// export function utilizaConjunto() {
//   return String(getGlobParam(globParams.UTILIZA_CONJUNTO)) === '1';
// }

// export function utilizaVisualizaoFacesSistema() {
//   return (
//     String(getGlobParam(globParams.UTILIZA_VISUALIZACAO_FACES_SISTEMA)) === '1'
//   );
// }

// export function solicitaAtualizacaoPartnumber() {
//   return (
//     String(getGlobParam(globParams.SOLICITA_ATUALIZACAO_PARTNUMBER)) === '1'
//   );
// }

// export function permitePartnumberAnteriores() {
//   return String(getGlobParam(globParams.PERMITE_PARTNUMBER_ANTERIORES)) === '1';
// }

// export function aprovacaoAutomaticaAtualizacaoPartnumber() {
//   return (
//     String(
//       getGlobParam(globParams.APROVACAO_AUTOMATICA_ATUALIZACAO_PARTNUMBER)
//     ) === '1'
//   );
// }

// export function usaIdiomaCatalogo() {
//   return getGlobParam(globParams.USA_IDIOMA_CATALOGO) === '1';
// }

// export function usaPdfCatalogoCdi() {
//   return getGlobParam(globParams.USA_PDF_CATALOGO_CDI) === '1';
// }

import { store } from '../store';

const globParams = {
  REDIRECIONA_PARA_CARRINHO: 1,
  ENVIA_EMAIL_SERVIDOR: 2,
  PERMITE_EMPRESA_CONVERSAO: 3,
  PERMITE_MENU_PERSONALIZADO: 4,
  PERMITE_GERACAO_TOKEN: 5,
  ROTULO_INTEGRACAO_EXT_EXTRA_01: 6,
  ROTULO_INTEGRACAO_EXT_EXTRA_02: 7,
  ROTULO_INTEGRACAO_EXT_EXTRA_03: 8,
  ROTULO_INTEGRACAO_EXT_EXTRA_04: 9,
  PERMITE_EMAIL_USUARIO_RESPONSAVEL: 10,
  PERMITE_SERIE_LOTE_CATALOGO: 11,
  ENVIA_WHATSAPP_SERVIDOR: 12,
  ENVIA_EMAIL_SOLICITAR: 13,
  ITEM_OS_SISMA: 14,
  USA_FILTRO_ANOFAB_NSERIE: 15,
  USA_MICROFONE: 16,
  NECESSITA_14_USA_MOTIVO_FALHA: 17,
  NECESSITA_14_USA_AGENTE_CAUSA: 18,
  NECESSITA_14_USA_SECAO_TRABALHO: 19,
  LIMITA_QTD_MAX: 20,
  LIMITA_QTD_MIN: 21,
  LIMITE_ITEM_QTD_ZERO: 22,
  QTD_ITEM_INIC_0: 23,
  TEMP_DISP_WHATSAPP: 24,
  VINCULA_CATALOGO_USUARIO: 25,
  UTILIZA_SOLICITAR_PECAS: 26,
  UTILIZA_CONJUNTO: 27,
  UTILIZA_VISUALIZACAO_FACES_SISTEMA: 28,
  SOLICITA_ATUALIZACAO_PARTNUMBER: 29,
  PERMITE_PARTNUMBER_ANTERIORES: 30,
  APROVACAO_AUTOMATICA_ATUALIZACAO_PARTNUMBER: 31,
  USA_IDIOMA_CATALOGO: 32,
  USA_PDF_CATALOGO_CDI: 33,
  REDUZ_TABELA_ITENS_HOME: 34,
  REMOVE_ERP_HOME: 35,
};

function getGlobParam(globParam) {
  /** verifica estado de autenticação */
  const { param } = store.getState();
  const { globParams: params = [] } = param || {};

  const chave = params.find((p) => p.chave === globParam);

  const { valor = 0 } = chave || {};

  return valor;
}

export function allowEmpCatalogConversor() {
  return getGlobParam(globParams.PERMITE_EMPRESA_CONVERSAO) === '1';
}

export function allowEmpCustomMenu() {
  return getGlobParam(globParams.PERMITE_MENU_PERSONALIZADO) === '1';
}

export function allowEmpTokenGenerate() {
  return getGlobParam(globParams.PERMITE_GERACAO_TOKEN) === '1';
}

export function redirectToCart() {
  return getGlobParam(globParams.REDIRECIONA_PARA_CARRINHO) === '1';
}

export function sendServerEmail() {
  return getGlobParam(globParams.ENVIA_EMAIL_SERVIDOR) === '1';
}

export function sendServerWhatsApp() {
  return getGlobParam(globParams.ENVIA_WHATSAPP_SERVIDOR) === '1';
}

export function labelExtExtra01() {
  return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_01);
}

export function labelExtExtra02() {
  return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_02);
}

export function labelExtExtra03() {
  return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_03);
}

export function labelExtExtra04() {
  return getGlobParam(globParams.ROTULO_INTEGRACAO_EXT_EXTRA_04);
}

export function permiteEmpEmailUsuarioReponsavel() {
  return getGlobParam(globParams.PERMITE_EMAIL_USUARIO_RESPONSAVEL) === '1';
}

export function permiteEmpSerieLoteCatalogo() {
  return getGlobParam(globParams.PERMITE_SERIE_LOTE_CATALOGO) === '1';
}

export function criaItemOSSisma() {
  return getGlobParam(globParams.ITEM_OS_SISMA) === '1';
}

export function usaMotivoFalha() {
  return getGlobParam(globParams.NECESSITA_14_USA_MOTIVO_FALHA) === '1';
}

export function usaAgenteCausa() {
  return getGlobParam(globParams.NECESSITA_14_USA_AGENTE_CAUSA) === '1';
}

export function usaSecaoTrab() {
  return getGlobParam(globParams.NECESSITA_14_USA_SECAO_TRABALHO) === '1';
}

export function enviaEmailSolicitacao() {
  return getGlobParam(globParams.ENVIA_EMAIL_SOLICITAR) === '1';
}

export function useDictaphone() {
  return getGlobParam(globParams.USA_MICROFONE) === '1';
}

export function limitaQtdMax() {
  return {
    active:
      String(getGlobParam(globParams.LIMITA_QTD_MAX)) === '1' ||
      String(getGlobParam(globParams.LIMITA_QTD_MAX)) === '2',
    value: Number(getGlobParam(globParams.LIMITA_QTD_MAX)),
  };
}

export function limitaQtdMin() {
  return {
    active:
      String(getGlobParam(globParams.LIMITA_QTD_MIN)) === '1' ||
      String(getGlobParam(globParams.LIMITA_QTD_MIN)) === '2',
    value: Number(getGlobParam(globParams.LIMITA_QTD_MIN)),
  };
}

export function limiteItemQtdZero() {
  return {
    active: Number(getGlobParam(globParams.LIMITE_ITEM_QTD_ZERO)) > 0,
    value: Number(getGlobParam(globParams.LIMITE_ITEM_QTD_ZERO)),
  };
}

export function qtdItemInic0() {
  return getGlobParam(globParams.QTD_ITEM_INIC_0) === '1';
}

export function tempDispWhatsapp() {
  return Number(getGlobParam(globParams.QTD_ITEM_INIC_0)) > 0;
}

export function vinculaCatalogoUsuario() {
  return String(getGlobParam(globParams.VINCULA_CATALOGO_USUARIO)) === '1';
}

export function utilizaSolicitarPecas() {
  return String(getGlobParam(globParams.UTILIZA_SOLICITAR_PECAS)) === '1';
}

export function utilizaConjunto() {
  return String(getGlobParam(globParams.UTILIZA_CONJUNTO)) === '1';
}

export function utilizaVisualizaoFacesSistema() {
  return (
    String(getGlobParam(globParams.UTILIZA_VISUALIZACAO_FACES_SISTEMA)) === '1'
  );
}

export function solicitaAtualizacaoPartnumber() {
  return (
    String(getGlobParam(globParams.SOLICITA_ATUALIZACAO_PARTNUMBER)) === '1'
  );
}

export function permitePartnumberAnteriores() {
  return String(getGlobParam(globParams.PERMITE_PARTNUMBER_ANTERIORES)) === '1';
}

export function aprovacaoAutomaticaAtualizacaoPartnumber() {
  return (
    String(
      getGlobParam(globParams.APROVACAO_AUTOMATICA_ATUALIZACAO_PARTNUMBER)
    ) === '1'
  );
}

/**
 * Habilita (por empresa) a escolha de idioma do catálogo na tela de
 * classificação. Parâmetro global de chave 32.
 */
export function usaIdiomaCatalogo() {
  return getGlobParam(globParams.USA_IDIOMA_CATALOGO) === '1';
}

/**
 * Habilita (para o usuário logado) a opção de abrir/baixar o PDF completo do
 * catálogo na navegação da Home. Parâmetro global de chave 33.
 */
export function usaPdfCatalogoCdi() {
  return getGlobParam(globParams.USA_PDF_CATALOGO_CDI) === '1';
}

export function usaWhatsapp() {
  return getGlobParam(globParams.TEMP_DISP_WHATSAPP) === '1';
}

export function reduzTabelaItensHome() {
  return getGlobParam(globParams.REDUZ_TABELA_ITENS_HOME) === '1';
}

export function removeERPHome() {
  return getGlobParam(globParams.REMOVE_ERP_HOME) === '1';
}
